import { render } from "./Dcase.vue?vue&type=template&id=0a0ba6ad&scoped=true"
import script from "./Dcase.vue?vue&type=script&lang=js"
export * from "./Dcase.vue?vue&type=script&lang=js"

import "./Dcase.vue?vue&type=style&index=0&id=0a0ba6ad&scoped=true&lang=css"

import exportComponent from "D:\\1\\2023-02-15\\doubles-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0ba6ad"]])

export default __exports__